<template>
  <div class="grp-password-input">
    <FieldValidate
      :id="name"
      :name="name"
      v-bind="attrs"
      :type="showPassword ? 'text' : 'password'"
      :required="isRequired"
      :class="[inputClass, 'grp-input-main-padding', { 'grp-input-main-error': errors[name], filled: isFilled }]"
      validate-on-input
    />
    <BaseLabel :for-name="name" :label="label" />
    <button type="button" @click.prevent="togglePassword" class="grp-password-button">
      <img src="@/assets/img/eye.svg" alt="Visualizar a senha" />
    </button>
  </div>
</template>

<script>
import { computed, ref, toRefs } from 'vue';
import BaseLabel from '@/components/BaseLabel';
import { Field as FieldValidate, useField } from 'vee-validate';

export default {
  name: 'PasswordInput',
  components: { BaseLabel, FieldValidate },
  props: {
    label: { type: Object, required: true },
    name: { type: String, required: true },
    errors: { type: Object, required: true },
    attrs: { type: Object, required: true },
  },
  setup(props) {
    const { attrs, name } = toRefs(props);
    const { value: inputValue } = useField(name);

    const showPassword = ref(false);
    const togglePassword = () => (showPassword.value = !showPassword.value);
    const isRequired = computed(() => attrs.value.rules?.includes('required'));

    const inputClass = computed(() => (attrs.value?.colorMode === 'light' ? 'grp-input-light' : 'grp-input-main'));

    const isFilled = computed(() => inputValue.value && inputValue.value.length > 0);

    return { isFilled, isRequired, showPassword, togglePassword, inputClass };
  },
};
</script>

<style lang="scss" scoped>
input[type='password']::-ms-reveal {
  display: none;
}

.grp-password-input {
  display: flex;
  flex-direction: column;
  position: relative;

  &:hover {
    .grp-password-button {
      opacity: 1;
    }
  }
}

.grp-input-main-padding {
  padding-right: 2.5rem;
}

.grp-password-button {
  position: absolute;
  cursor: pointer;
  opacity: 0;
  top: 2.5rem;
  right: 1rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;

  &:focus {
    opacity: 1;
  }
}
</style>
